import React from 'react';
import { call } from '../utilities/http';
import { FormattedMessage } from 'react-intl';
import { Snackbar } from '../components/snackbar';
import { LOADING, COMPLETE, INVITES_GET_ALL_OK, INVITES_GET_ROLES_OK, SAVING } from './types';
import { RoleDefinitions } from './../utilities/roles';

const defaultState = {
    list: undefined,
    roles: undefined
};

/**
 * Invites state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case INVITES_GET_ALL_OK:
            return { ...state, list: action.data };

        case INVITES_GET_ROLES_OK:
            return { ...state, roles: action.data };

        default:
            return state;
    }
}

export function getInvites(role, onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.getInvites'} defaultMessage={'Unable to retrieve invites.'} />;
    const { id, type } = role;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/${type}/${id}/invites` })
            .then(response => {
                dispatch({ type: INVITES_GET_ALL_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getInvite(id, onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.getInvite'} defaultMessage={'Unable to retrieve invite details.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/invite/${id}` })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function sendInvite(invite, role, onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.sendInvite'} defaultMessage={'Unable to send invite.'} />;

    const { id, type } = role;
    let data = {};

    switch (invite.role) {
        case RoleDefinitions.Admin.type:
        case RoleDefinitions.AdminFinance.type:
        case RoleDefinitions.AdminHumanResources.type:
        case RoleDefinitions.Witness.type:
            data = { ...invite, resource: type, resource_id: id };
            break;

        case RoleDefinitions.Client.type:
        case RoleDefinitions.ClientHiringManager.type:
        case RoleDefinitions.ClientTimesheetApprover.type:
        case RoleDefinitions.ClientAPI.type:
            data = { ...invite, resource: 'client', resource_id: invite.clientId };
            break;

        default:
            data = { ...invite };
            break;
    }

    data.glHr = undefined;
    data.clientId = undefined;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/invite`, method: 'POST', body: data })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function cancelInvite(invite, onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.cancelInvite'} defaultMessage={'Unable to cancel invite.'} />;
    const { id } = invite;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/invite/${id}`, method: 'DELETE' })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function acceptInvite(inviteId, onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.acceptInvite'} defaultMessage={'Unable to accept invite.'} />;
    if (!inviteId) {
        return;
    }

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/invite/${inviteId}/action/accept`, method: 'POST' })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function updateInvite(invite, onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.updateInvite'} defaultMessage={'Unable to update invite.'} />;
    const { id } = invite;

    invite.glHr = undefined;
    invite.clientId = undefined;

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/invite/${id}`, method: 'PUT', body: invite })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function resendInvite(invite, onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.resendInvite'} defaultMessage={'Unable to resend invite.'} />;
    const { id } = invite;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/invite/${id}/resend`, method: 'POST' })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function resendJobInvite(job, onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.resendJobInvite'} defaultMessage={'Unable to resend job invite.'} />;
    const { id } = job;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${id}/resend`, method: 'POST' })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getRoles(onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.getRoles'} defaultMessage={'Unable to retrieve user roles.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: '/roles' })
            .then(response => {
                dispatch({ type: INVITES_GET_ROLES_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/invites.jsx